import { em } from 'polished'
import styled, { css } from 'styled-components'

import { Text } from 'styles/components/typography'

export const SeparateLine = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  margin: ${({ isBefore }) => `${em(isBefore ? 30 : 15)} 0 ${em(25)}`};

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    ${({ isBefore, theme }) =>
      isBefore &&
      css`
        background: ${theme.colors.blackOp07};
      `}

    ${p => p.theme.mq.upMd} {
      background: ${p => p.theme.colors.blackOp07};
    }
  }
`

export const SeparateLineText = styled(Text)`
  position: relative;
  z-index: 1;
  background: ${p => p.theme.colors.grayOp06NonTransp};
  padding: 0 ${em(40)};
`

export const PaymentSeparateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${em(40)};
`
